var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "frm" } },
    [
      _c(
        "win-layer-pop",
        { staticClass: "inquiry_surcharge_pop" },
        [
          _vm.customComponent
            ? _c(_vm.customComponent, {
                tag: "component",
                attrs: { "parent-info": _vm.surChargeParams },
                on: { close: _vm.closePopup },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "content_box beforetab" }, [
        _c("table", { staticStyle: { width: "100%" } }, [
          _c("tbody", [
            _c("tr", [
              _c(
                "td",
                { staticStyle: { width: "200px", "padding-right": "10px" } },
                [
                  _c("th", { staticStyle: { "text-align": "center" } }, [
                    _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.001"))),
                  ]),
                  _c("e-auto-complete-place", {
                    attrs: {
                      id: "polPol",
                      "ctr-cd": _vm.params.porCtrCd,
                      "plc-cd": _vm.params.porPlcCd,
                      "is-char": true,
                      "is-char-alert": true,
                      plaholder: "Enter Origin",
                    },
                    on: { change: _vm.changePol },
                  }),
                ],
                1
              ),
              _c(
                "td",
                { staticStyle: { width: "200px", "padding-right": "10px" } },
                [
                  _c("th", { staticStyle: { "text-align": "center" } }, [
                    _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.002"))),
                  ]),
                  _c("e-auto-complete-place", {
                    attrs: {
                      id: "podPod",
                      "ctr-cd": _vm.params.dlyCtrCd,
                      "plc-cd": _vm.params.dlyPlcCd,
                      "is-char": true,
                      "is-char-alert": true,
                      plaholder: "Enter Destination",
                    },
                    on: { change: _vm.changePod },
                  }),
                ],
                1
              ),
              _c(
                "td",
                { staticStyle: { width: "150px", "padding-right": "10px" } },
                [
                  _c("th", { staticStyle: { "text-align": "center" } }, [
                    _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.003"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "input_calendar" },
                    [
                      _c("e-date-picker", {
                        staticStyle: { width: "147px" },
                        attrs: { id: "etd" },
                        model: {
                          value: _vm.params.etd,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "etd", $$v)
                          },
                          expression: "params.etd",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "td",
                { staticStyle: { width: "247px", "padding-right": "10px" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex_box",
                      staticStyle: { "justify-content": "flex-end" },
                    },
                    [
                      _c("div", { staticStyle: { "margin-left": "25px" } }, [
                        _c("th", { staticStyle: { "text-align": "center" } }, [
                          _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.027"))),
                        ]),
                        _c("span", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cntr20Yn,
                                expression: "cntr20Yn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "cntr20Yn",
                              "true-value": "1",
                              "false-value": "0",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.cntr20Yn)
                                ? _vm._i(_vm.cntr20Yn, null) > -1
                                : _vm._q(_vm.cntr20Yn, "1"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.cntr20Yn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "1" : "0"
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.cntr20Yn = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.cntr20Yn = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.cntr20Yn = $$c
                                }
                              },
                            },
                          }),
                          _vm._m(0),
                        ]),
                        _c("span", { staticClass: "ml20" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cntr40Yn,
                                expression: "cntr40Yn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "cntr40Yn",
                              "true-value": "1",
                              "false-value": "0",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.cntr40Yn)
                                ? _vm._i(_vm.cntr40Yn, null) > -1
                                : _vm._q(_vm.cntr40Yn, "1"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.cntr40Yn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "1" : "0"
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.cntr40Yn = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.cntr40Yn = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.cntr40Yn = $$c
                                }
                              },
                            },
                          }),
                          _vm._m(1),
                        ]),
                        _c("span", { staticClass: "ml20" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cntrHzYn,
                                expression: "cntrHzYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "cntrHzYn",
                              "true-value": "1",
                              "false-value": "0",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.cntrHzYn)
                                ? _vm._i(_vm.cntrHzYn, null) > -1
                                : _vm._q(_vm.cntrHzYn, "1"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.cntrHzYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "1" : "0"
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.cntrHzYn = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.cntrHzYn = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.cntrHzYn = $$c
                                }
                              },
                            },
                          }),
                          _vm._m(2),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _c("td", { staticStyle: { "padding-left": "49px" } }, [
                _c("div", { staticClass: "flex_box mt5" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button blue lg ml5",
                      staticStyle: { height: "32px", width: "50px" },
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.fnSearchSurCharge()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.004")))]
                  ),
                ]),
              ]),
              _c(
                "td",
                {
                  staticStyle: { "padding-top": "5px" },
                  attrs: { colspan: "2" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex_box",
                      staticStyle: { "flex-direction": "row-reverse" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "position_relative",
                          staticStyle: { "margin-left": "5px" },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "button grey lg",
                              staticStyle: {
                                "background-color": "#E5EEFF",
                                overflow: "hidden",
                                "white-space": "nowrap",
                                "line-height": "0",
                                color: "black",
                                border: "1px solid #C7DAFF",
                                height: "32px",
                                width: "90px",
                                "padding-left": "5px",
                                "align-content": "center",
                                "font-size": "small",
                                "margin-left": "10px",
                              },
                              attrs: { id: "histo" },
                              on: {
                                click: function ($event) {
                                  _vm.showHisto = !_vm.showHisto
                                },
                              },
                            },
                            [
                              _c("a", {
                                staticClass: "tbl_icon new_histo",
                                attrs: { id: "histo" },
                              }),
                              _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.007"))),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showHisto,
                                  expression: "showHisto",
                                },
                              ],
                              staticClass:
                                "tooltip_wrap short position_absolute",
                              staticStyle: {
                                "background-color": "#F0F5FF",
                                width: "285px",
                                left: "9px",
                                top: "31px",
                                "padding-bottom": "11px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cont",
                                  staticStyle: {
                                    padding: "0px",
                                    "margin-right": "10px",
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "close",
                                      staticStyle: { right: "16px" },
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showHisto = false
                                        },
                                      },
                                    },
                                    [_vm._v("close")]
                                  ),
                                  _c("ul", { staticClass: "bul_list_sm t2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "content_box mt10 ml10",
                                        staticStyle: { padding: "0" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex_box",
                                            staticStyle: {
                                              padding: "4px",
                                              "background-color": "#E5EEFF",
                                              height: "31px",
                                            },
                                          },
                                          [
                                            _c("a", {
                                              staticClass: "tbl_icon new_histo",
                                            }),
                                            _c(
                                              "th",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                  "padding-left": "9px",
                                                  "font-size": "medium",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "msg.FARE010T010_NEW.007"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticStyle: { padding: "4px" } },
                                          _vm._l(
                                            _vm.recentScheduleList,
                                            function (item, index) {
                                              return _c("ul", { key: index }, [
                                                _c("ul", [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "radio",
                                                      id: item.logRno,
                                                      name: "mysch",
                                                    },
                                                    domProps: {
                                                      value: item.logRno,
                                                      checked:
                                                        item.logRno ===
                                                        _vm.schId,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.selectRecentSchedule(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        id: "searchRadio",
                                                        for: item.logRno,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "offscreen",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.logRno)
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.polPortNm
                                                          ) +
                                                          " "
                                                      ),
                                                      item.tsYn === "Y"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "arr",
                                                            },
                                                            [_vm._v(" > ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.tsYn === "Y"
                                                              ? "(T/S) " +
                                                                  item.pod1PortNm
                                                              : ""
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "span",
                                                        { staticClass: "arr" },
                                                        [_vm._v(" > ")]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.podPortNm
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("span", { staticClass: "position_relative" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button grey lg",
                            staticStyle: {
                              "background-color": "#E5EEFF",
                              overflow: "hidden",
                              "white-space": "nowrap",
                              "line-height": "0",
                              color: "black",
                              border: "1px solid #C7DAFF",
                              height: "32px",
                              width: "90px",
                              "padding-left": "5px",
                              "align-content": "center",
                              "font-size": "small",
                              "margin-left": "10px",
                            },
                            attrs: { id: "favor" },
                            on: {
                              click: function ($event) {
                                _vm.showFavor = !_vm.showFavor
                              },
                            },
                          },
                          [
                            _c("a", {
                              staticClass: "tbl_icon new_favor",
                              attrs: { id: "favor" },
                            }),
                            _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.006"))),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showFavor,
                                expression: "showFavor",
                              },
                            ],
                            staticClass: "tooltip_wrap short position_absolute",
                            staticStyle: {
                              "background-color": "#F0F5FF",
                              width: "285px",
                              left: "9px",
                              top: "31px",
                              "padding-bottom": "11px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cont",
                                staticStyle: {
                                  padding: "0px",
                                  "margin-right": "10px",
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "close",
                                    staticStyle: { right: "16px" },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.showFavor = false
                                      },
                                    },
                                  },
                                  [_vm._v("close")]
                                ),
                                _c("ul", { staticClass: "bul_list_sm t2" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "content_box mt10 ml10",
                                      staticStyle: { padding: "0" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex_box",
                                          staticStyle: {
                                            padding: "4px",
                                            "background-color": "#E5EEFF",
                                            height: "31px",
                                          },
                                        },
                                        [
                                          _c("a", {
                                            staticClass: "tbl_icon new_favor",
                                          }),
                                          _c(
                                            "th",
                                            {
                                              staticStyle: {
                                                "text-align": "center",
                                                "padding-left": "9px",
                                                "font-size": "medium",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "msg.FARE010T010_NEW.006"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticStyle: { padding: "4px" } },
                                        _vm._l(
                                          _vm.myScheduleList,
                                          function (list, index) {
                                            return _c(
                                              "ul",
                                              {
                                                key: index,
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "radio",
                                                    id: list.schId,
                                                    name: "mysch",
                                                  },
                                                  domProps: {
                                                    value: list.schId,
                                                    checked:
                                                      list.schId === _vm.schId,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectMySchedule(
                                                        list
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      id: "searchRadio",
                                                      for: list.schId,
                                                    },
                                                  },
                                                  [
                                                    _c("span"),
                                                    _vm._v(
                                                      _vm._s(list.polNm2) +
                                                        " > " +
                                                        _vm._s(list.podNm2)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isFixed && _vm.searchYn,
              expression: "isFixed && searchYn",
            },
          ],
          staticClass: "content_box mt10",
          staticStyle: {
            "border-color": "#2441BA",
            position: "fixed",
            top: "43px",
            "z-index": "101",
            width: "1250px",
          },
        },
        [
          _c("div", { staticClass: "flex_box" }, [
            _c(
              "div",
              { staticStyle: { width: "90%", "margin-right": "20px" } },
              [
                _c(
                  "p",
                  {
                    staticClass: "port",
                    staticStyle: {
                      color: "#345EBB",
                      height: "45px",
                      "font-size": "x-large",
                    },
                  },
                  [
                    _c("span", { staticStyle: { "padding-top": "3px" } }, [
                      _vm._v(_vm._s(_vm.params.polNm)),
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          background:
                            "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlFNkVCMDQ3RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlFNkVCMDQ4RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUU2RUIwNDVGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUU2RUIwNDZGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kdiepAAAACVBMVEWDrdz///8HW7mfiL2lAAAAIElEQVR42mJgYGRkZGBiABFAEkgwMcAIBqgESAlAgAEAAwIAJbZf+5AAAAAASUVORK5CYII=) no-repeat 0 18px",
                        },
                      },
                      [_vm._v(_vm._s(_vm.params.podNm))]
                    ),
                    _vm.$ekmtcCommon.isNotEmpty(_vm.userCtrCd)
                      ? _c(
                          "span",
                          {
                            staticClass: "icon",
                            staticStyle: { background: "none" },
                          },
                          [
                            _vm.myScheduleOrNot === "N"
                              ? _c("div", [
                                  _c("button", {
                                    staticClass: "tbl_icon myschedule",
                                    staticStyle: { "margin-top": "-5px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.fnAddMySchedule()
                                      },
                                    },
                                  }),
                                ])
                              : _c("div", [
                                  _c("button", {
                                    staticClass: "tbl_icon myschedule on",
                                    staticStyle: { "margin-top": "-5px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteMyScheduleStar(
                                          _vm.schId
                                        )
                                      },
                                    },
                                  }),
                                ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.tapStatus === 1 && this.startDtGP !== ""
                      ? _c(
                          "a",
                          {
                            staticStyle: {
                              display: "list-item",
                              "margin-left": "25px",
                              "margin-top": "13px",
                              float: "right",
                              "font-size": "small",
                              color: "black",
                            },
                          },
                          [
                            _vm._v(
                              "Validity Period : " +
                                _vm._s(this.startDtGP) +
                                " ~ " +
                                _vm._s(this.endDtGP)
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.tapStatus === 1 && this.frtAppNoGP !== ""
                      ? _c(
                          "a",
                          {
                            staticStyle: {
                              display: "list-item",
                              "margin-top": "13px",
                              float: "right",
                              "font-size": "small",
                              color: "black",
                            },
                          },
                          [_vm._v("SC No. : " + _vm._s(this.frtAppNoGP))]
                        )
                      : _vm._e(),
                    _vm.tapStatus === 2 && this.startDtRF !== ""
                      ? _c(
                          "a",
                          {
                            staticStyle: {
                              display: "list-item",
                              "margin-left": "25px",
                              "margin-top": "13px",
                              float: "right",
                              "font-size": "small",
                              color: "black",
                            },
                          },
                          [
                            _vm._v(
                              "Validity Period : " +
                                _vm._s(this.startDtRF) +
                                " ~ " +
                                _vm._s(this.endDtRF)
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.tapStatus === 2 && this.frtAppNoRF !== ""
                      ? _c(
                          "a",
                          {
                            staticStyle: {
                              display: "list-item",
                              "margin-top": "13px",
                              float: "right",
                              "font-size": "small",
                              color: "black",
                            },
                          },
                          [_vm._v("SC No. : " + _vm._s(this.frtAppNoRF))]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
            _c("div", [
              _c(
                "a",
                {
                  staticClass: "button blue sm",
                  staticStyle: {
                    "border-color": "#C7DAFF",
                    "background-color": "#E5EEFF",
                    color: "#075bb9",
                    "font-size": "smaller",
                  },
                  attrs: { id: "freeTime" },
                  on: {
                    click: function ($event) {
                      _vm.showFree = !_vm.showFree
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "tbl_icon new_freetime",
                    staticStyle: { "background-position": "-2px -1px" },
                  }),
                  _vm._v("Free Time"),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.searchYn,
              expression: "searchYn",
            },
          ],
          ref: "headerXPos",
          staticClass: "content_box mt10",
          staticStyle: { "border-color": "#2441BA" },
        },
        [
          _c("div", { staticClass: "flex_box" }, [
            _c(
              "div",
              { staticStyle: { width: "90%", "margin-right": "20px" } },
              [
                _c(
                  "p",
                  {
                    staticClass: "port",
                    staticStyle: {
                      color: "#345EBB",
                      height: "45px",
                      "font-size": "x-large",
                    },
                  },
                  [
                    _c("span", { staticStyle: { "padding-top": "3px" } }, [
                      _vm._v(_vm._s(_vm.searchPolNm)),
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          background:
                            "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlFNkVCMDQ3RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlFNkVCMDQ4RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUU2RUIwNDVGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUU2RUIwNDZGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kdiepAAAACVBMVEWDrdz///8HW7mfiL2lAAAAIElEQVR42mJgYGRkZGBiABFAEkgwMcAIBqgESAlAgAEAAwIAJbZf+5AAAAAASUVORK5CYII=) no-repeat 0 18px",
                        },
                      },
                      [_vm._v(_vm._s(_vm.searchPodNm))]
                    ),
                    _vm.$ekmtcCommon.isNotEmpty(_vm.userCtrCd)
                      ? _c(
                          "span",
                          {
                            staticClass: "icon",
                            staticStyle: { background: "none" },
                          },
                          [
                            _vm.myScheduleOrNot === "N"
                              ? _c("div", [
                                  _c("button", {
                                    staticClass: "tbl_icon myschedule",
                                    staticStyle: { "margin-top": "-5px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.fnAddMySchedule()
                                      },
                                    },
                                  }),
                                ])
                              : _c("div", [
                                  _c("button", {
                                    staticClass: "tbl_icon myschedule on",
                                    staticStyle: { "margin-top": "-5px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteMyScheduleStar(
                                          _vm.schId
                                        )
                                      },
                                    },
                                  }),
                                ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.tapStatus === 1 && this.startDtGP !== ""
                      ? _c(
                          "a",
                          {
                            staticStyle: {
                              display: "list-item",
                              "margin-left": "25px",
                              "margin-top": "13px",
                              float: "right",
                              "font-size": "small",
                              color: "black",
                            },
                          },
                          [
                            _vm._v(
                              "Validity Period : " +
                                _vm._s(this.startDtGP) +
                                " ~ " +
                                _vm._s(this.endDtGP)
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.tapStatus === 1 && this.frtAppNoGP !== ""
                      ? _c(
                          "a",
                          {
                            staticStyle: {
                              display: "list-item",
                              "margin-top": "13px",
                              float: "right",
                              "font-size": "small",
                              color: "black",
                            },
                          },
                          [_vm._v("SC No. : " + _vm._s(this.frtAppNoGP))]
                        )
                      : _vm._e(),
                    _vm.tapStatus === 2 && this.startDtRF !== ""
                      ? _c(
                          "a",
                          {
                            staticStyle: {
                              display: "list-item",
                              "margin-left": "25px",
                              "margin-top": "13px",
                              float: "right",
                              "font-size": "small",
                              color: "black",
                            },
                          },
                          [
                            _vm._v(
                              "Validity Period : " +
                                _vm._s(this.startDtRF) +
                                " ~ " +
                                _vm._s(this.endDtRF)
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.tapStatus === 2 && this.frtAppNoRF !== ""
                      ? _c(
                          "a",
                          {
                            staticStyle: {
                              display: "list-item",
                              "margin-top": "13px",
                              float: "right",
                              "font-size": "small",
                              color: "black",
                            },
                          },
                          [_vm._v("SC No. : " + _vm._s(this.frtAppNoRF))]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
            _c("div", [
              _c(
                "a",
                {
                  staticClass: "button blue sm",
                  staticStyle: {
                    "border-color": "#C7DAFF",
                    "background-color": "#E5EEFF",
                    color: "#075bb9",
                    "font-size": "smaller",
                  },
                  attrs: { id: "freeTime" },
                  on: {
                    click: function ($event) {
                      _vm.showFree = !_vm.showFree
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "tbl_icon new_freetime",
                    staticStyle: { "background-position": "-2px -1px" },
                  }),
                  _vm._v("Free Time"),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _c("table", { staticStyle: { width: "1260px" } }, [
        _vm._m(3),
        _c("tbody", [
          _c("tr", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.searchYn,
                    expression: "!searchYn",
                  },
                ],
                staticClass: "content_box mt10",
                staticStyle: {
                  "align-content": "center",
                  "text-align": "center",
                  "background-color": "rgba(246, 249, 255)",
                  height: "450px",
                  width: "132.4%",
                },
              },
              [_c("a", [_vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.008")))])]
            ),
            _c("td", { staticStyle: { "align-content": "flex-start" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.searchYn,
                      expression: "searchYn",
                    },
                  ],
                  staticClass: "content_box mt10",
                },
                [
                  _vm._m(4),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "15px",
                        cursor: "pointer",
                        float: "right",
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "font-size": "small",
                            color: "#075bb9",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.showDetail()
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("msg.FARE010T010_NEW.064")) + " "
                          ),
                          _c("a", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.detailYn !== "Y",
                                expression: "detailYn !== 'Y'",
                              },
                            ],
                            staticClass: "tbl_icon new_plus",
                          }),
                          _c("a", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.detailYn === "Y",
                                expression: "detailYn === 'Y'",
                              },
                            ],
                            staticClass: "tbl_icon new_minus",
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "tab" }, [
                    _c("ul", [
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.surChargeListDry.length > 0,
                              expression: "surChargeListDry.length > 0",
                            },
                          ],
                          staticClass: "on",
                          attrs: { id: "tab1" },
                          on: {
                            click: function ($event) {
                              return _vm.selectTab(1)
                            },
                          },
                        },
                        [
                          _c("a", { attrs: { href: "javascript:void(0)" } }, [
                            _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.009"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.surChargeListRee.length > 0,
                              expression: "surChargeListRee.length > 0",
                            },
                          ],
                          attrs: { id: "tab2" },
                          on: {
                            click: function ($event) {
                              return _vm.selectTab(2)
                            },
                          },
                        },
                        [
                          _c("a", { attrs: { href: "javascript:void(0)" } }, [
                            _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.010"))),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tapStatus === 1,
                          expression: "tapStatus === 1",
                        },
                      ],
                      staticClass: "content_box",
                      staticStyle: { "background-color": "#F0F5FF" },
                    },
                    [
                      _c(
                        "div",
                        {
                          attrs: { id: "print_screen_gp" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("table", { staticClass: "tbl_col mt10" }, [
                            _c("colgroup", [
                              _c("col", { attrs: { width: "30%" } }),
                              _c("col", { attrs: { width: "12%" } }),
                              _c("col", { attrs: { width: "10%" } }),
                              _c("col", { attrs: { width: "12%" } }),
                              _c("col", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.v20Yn,
                                    expression: "v20Yn",
                                  },
                                ],
                                attrs: { width: "12%" },
                              }),
                              _c("col", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.v40Yn,
                                    expression: "v40Yn",
                                  },
                                ],
                                attrs: { width: "12%" },
                              }),
                              _c("col", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.v40Yn,
                                    expression: "v40Yn",
                                  },
                                ],
                                attrs: { width: "12%" },
                              }),
                            ]),
                            _c("thead", [
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("Freight Charges")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("Currency")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("Type")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("Cargo")]
                                ),
                                _c(
                                  "th",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.v20Yn,
                                        expression: "v20Yn",
                                      },
                                    ],
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("20'")]
                                ),
                                _c(
                                  "th",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.v40Yn,
                                        expression: "v40Yn",
                                      },
                                    ],
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("40'")]
                                ),
                                _c(
                                  "th",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.v40Yn,
                                        expression: "v40Yn",
                                      },
                                    ],
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("HC")]
                                ),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.surChargeListDry, function (row, idx) {
                                return _c("tr", { key: idx }, [
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.cgoTypCd !== "01" &&
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.cgoTypCd !== '01' && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                      staticClass: "text_left",
                                      attrs: {
                                        rowspan: row.frtCd == "O/F" ? 2 : 1,
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: `idxGP${idx}` } },
                                        [
                                          _c("span", [_vm._v(" ")]),
                                          _vm._v(_vm._s(row.frtCdNm)),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.curCd))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.cntrTypCd === "RF"
                                            ? "Reefer"
                                            : row.cntrTypCd
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.cgoTypNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v20Yn &&
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v20Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      row.cntrTypCd === "GP"
                                        ? _c("div", [
                                            row.rate20 !== "" &&
                                            row.rate20 !== "0" &&
                                            _vm.frtAppNo === "" &&
                                            _vm.of20Rate !== "" &&
                                            _vm.of20Rate !== undefined
                                              ? _c("div", [
                                                  _c("del", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rate20) +
                                                            parseInt(
                                                              _vm.of20Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v("   "),
                                                  _c("img", {
                                                    staticStyle: {
                                                      "margin-top": "6px",
                                                    },
                                                    attrs: {
                                                      src: require("../../assets/images/common/icon_port_arrow.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "   " +
                                                      _vm._s(
                                                        _vm.calcPromotionDC(
                                                          "20",
                                                          parseInt(row.rate20) +
                                                            parseInt(
                                                              _vm.of20Rate
                                                            ),
                                                          row.frtCd,
                                                          row.cntrTypCd,
                                                          row.cgoTypNm
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : row.rate20 !== "" &&
                                                row.rate20 !== "0" &&
                                                _vm.of20Rate !== "" &&
                                                _vm.of20Rate !== undefined
                                              ? _c("div", [
                                                  _c("del", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rate20) +
                                                            parseInt(
                                                              _vm.of20Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v("   "),
                                                  _c("img", {
                                                    staticStyle: {
                                                      "margin-top": "6px",
                                                    },
                                                    attrs: {
                                                      src: require("../../assets/images/common/icon_port_arrow.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "   " +
                                                      _vm._s(
                                                        _vm.calcPromotionDC(
                                                          "20",
                                                          parseInt(row.rate20) +
                                                            parseInt(
                                                              _vm.of20Rate
                                                            ),
                                                          row.frtCd,
                                                          row.cntrTypCd,
                                                          row.cgoTypNm
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _c("div", [
                                                  row.rate20 !== "" &&
                                                  row.rate20 !== "0" &&
                                                  _vm.frtAppNo === "" &&
                                                  _vm.of20Rate !== "" &&
                                                  _vm.of20Rate !== undefined
                                                    ? _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$ekmtcCommon.changeNumberFormat(
                                                                parseInt(
                                                                  row.rate20
                                                                ) +
                                                                  parseInt(
                                                                    _vm.of20Rate
                                                                  ),
                                                                {
                                                                  isComma: true,
                                                                }
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : row.rate20 !== "" &&
                                                      row.rate20 !== "0" &&
                                                      _vm.of20Rate !== "" &&
                                                      _vm.of20Rate !== undefined
                                                    ? _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$ekmtcCommon.changeNumberFormat(
                                                                parseInt(
                                                                  row.rate20
                                                                ) +
                                                                  parseInt(
                                                                    _vm.of20Rate
                                                                  ),
                                                                {
                                                                  isComma: true,
                                                                }
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$ekmtcCommon.changeNumberFormat(
                                                              row.rate20,
                                                              { isComma: true }
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                ]),
                                          ])
                                        : _c("div", [
                                            row.rate20 !== "" &&
                                            row.rate20 !== "0" &&
                                            _vm.frtAppNo === "" &&
                                            _vm.of20Rate !== "" &&
                                            _vm.of20Rate !== undefined
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rate20) +
                                                            parseInt(
                                                              _vm.of20Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : row.rate20 !== "" &&
                                                row.rate20 !== "0" &&
                                                _vm.of20Rate !== "" &&
                                                _vm.of20Rate !== undefined
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rate20) +
                                                            parseInt(
                                                              _vm.of20Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ekmtcCommon.changeNumberFormat(
                                                        row.rate20,
                                                        { isComma: true }
                                                      )
                                                    )
                                                  ),
                                                ]),
                                          ]),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      row.cntrTypCd === "GP"
                                        ? _c("div", [
                                            row.rate40 !== "" &&
                                            row.rate40 !== "0" &&
                                            _vm.frtAppNo === "" &&
                                            _vm.of40Rate !== "" &&
                                            _vm.of40Rate !== undefined
                                              ? _c("div", [
                                                  _c("del", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rate40) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v("   "),
                                                  _c("img", {
                                                    staticStyle: {
                                                      "margin-top": "6px",
                                                    },
                                                    attrs: {
                                                      src: require("../../assets/images/common/icon_port_arrow.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "   " +
                                                      _vm._s(
                                                        _vm.calcPromotionDC(
                                                          "40",
                                                          parseInt(row.rate40) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          row.frtCd,
                                                          row.cntrTypCd,
                                                          row.cgoTypNm
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : row.rate40 !== "" &&
                                                row.rate40 !== "0" &&
                                                _vm.of40Rate !== "" &&
                                                _vm.of40Rate !== undefined
                                              ? _c("div", [
                                                  _c("del", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rate40) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v("   "),
                                                  _c("img", {
                                                    staticStyle: {
                                                      "margin-top": "6px",
                                                    },
                                                    attrs: {
                                                      src: require("../../assets/images/common/icon_port_arrow.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "   " +
                                                      _vm._s(
                                                        _vm.calcPromotionDC(
                                                          "40",
                                                          parseInt(row.rate40) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          row.frtCd,
                                                          row.cntrTypCd,
                                                          row.cgoTypNm
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _c("div", [
                                                  row.rate40 !== "" &&
                                                  row.rate40 !== "0" &&
                                                  _vm.frtAppNo === "" &&
                                                  _vm.of40Rate !== "" &&
                                                  _vm.of40Rate !== undefined
                                                    ? _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$ekmtcCommon.changeNumberFormat(
                                                                parseInt(
                                                                  row.rate40
                                                                ) +
                                                                  parseInt(
                                                                    _vm.of40Rate
                                                                  ),
                                                                {
                                                                  isComma: true,
                                                                }
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : row.rate40 !== "" &&
                                                      row.rate40 !== "0" &&
                                                      _vm.of40Rate !== "" &&
                                                      _vm.of40Rate !== undefined
                                                    ? _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$ekmtcCommon.changeNumberFormat(
                                                                parseInt(
                                                                  row.rate40
                                                                ) +
                                                                  parseInt(
                                                                    _vm.of40Rate
                                                                  ),
                                                                {
                                                                  isComma: true,
                                                                }
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$ekmtcCommon.changeNumberFormat(
                                                              row.rate40,
                                                              { isComma: true }
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                ]),
                                          ])
                                        : _c("div", [
                                            row.rate40 !== "" &&
                                            row.rate40 !== "0" &&
                                            _vm.frtAppNo === "" &&
                                            _vm.of40Rate !== "" &&
                                            _vm.of40Rate !== undefined
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rate40) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : row.rate40 !== "" &&
                                                row.rate40 !== "0" &&
                                                _vm.of40Rate !== "" &&
                                                _vm.of40Rate !== undefined
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rate40) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ekmtcCommon.changeNumberFormat(
                                                        row.rate40,
                                                        { isComma: true }
                                                      )
                                                    )
                                                  ),
                                                ]),
                                          ]),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      row.cntrTypCd === "GP"
                                        ? _c("div", [
                                            row.rateHc !== "" &&
                                            row.rateHc !== "0" &&
                                            _vm.frtAppNo === "" &&
                                            _vm.of40Rate !== "" &&
                                            _vm.of40Rate !== undefined
                                              ? _c("div", [
                                                  _c("del", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rateHc) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v("   "),
                                                  _c("img", {
                                                    staticStyle: {
                                                      "margin-top": "6px",
                                                    },
                                                    attrs: {
                                                      src: require("../../assets/images/common/icon_port_arrow.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "   " +
                                                      _vm._s(
                                                        _vm.calcPromotionDC(
                                                          "40",
                                                          parseInt(row.rateHc) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          row.frtCd,
                                                          row.cntrTypCd,
                                                          row.cgoTypNm
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : row.rateHc !== "" &&
                                                row.rateHc !== "0" &&
                                                _vm.of40Rate !== "" &&
                                                _vm.of40Rate !== undefined
                                              ? _c("div", [
                                                  _c("del", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rateHc) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v("   "),
                                                  _c("img", {
                                                    staticStyle: {
                                                      "margin-top": "6px",
                                                    },
                                                    attrs: {
                                                      src: require("../../assets/images/common/icon_port_arrow.png"),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "   " +
                                                      _vm._s(
                                                        _vm.calcPromotionDC(
                                                          "40",
                                                          parseInt(row.rateHc) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          row.frtCd,
                                                          row.cntrTypCd,
                                                          row.cgoTypNm
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _c("div", [
                                                  row.rateHc !== "" &&
                                                  row.rateHc !== "0" &&
                                                  _vm.frtAppNo === "" &&
                                                  _vm.of40Rate !== "" &&
                                                  _vm.of40Rate !== undefined
                                                    ? _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$ekmtcCommon.changeNumberFormat(
                                                                parseInt(
                                                                  row.rateHc
                                                                ) +
                                                                  parseInt(
                                                                    _vm.of40Rate
                                                                  ),
                                                                {
                                                                  isComma: true,
                                                                }
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : row.rateHc !== "" &&
                                                      row.rateHc !== "0" &&
                                                      _vm.of40Rate !== "" &&
                                                      _vm.of40Rate !== undefined
                                                    ? _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$ekmtcCommon.changeNumberFormat(
                                                                parseInt(
                                                                  row.rateHc
                                                                ) +
                                                                  parseInt(
                                                                    _vm.of40Rate
                                                                  ),
                                                                {
                                                                  isComma: true,
                                                                }
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$ekmtcCommon.changeNumberFormat(
                                                              row.rateHc,
                                                              { isComma: true }
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                ]),
                                          ])
                                        : _c("div", [
                                            row.rateHc !== "" &&
                                            row.rateHc !== "0" &&
                                            _vm.frtAppNo === "" &&
                                            _vm.of40Rate !== "" &&
                                            _vm.of40Rate !== undefined
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rateHc) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : row.rateHc !== "" &&
                                                row.rateHc !== "0" &&
                                                _vm.of40Rate !== "" &&
                                                _vm.of40Rate !== undefined
                                              ? _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$ekmtcCommon.changeNumberFormat(
                                                          parseInt(row.rateHc) +
                                                            parseInt(
                                                              _vm.of40Rate
                                                            ),
                                                          { isComma: true }
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ekmtcCommon.changeNumberFormat(
                                                        row.rateHc,
                                                        { isComma: true }
                                                      )
                                                    )
                                                  ),
                                                ]),
                                          ]),
                                    ]
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]),
                          _c(
                            "table",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.detailYn === "Y",
                                  expression: "detailYn === 'Y'",
                                },
                              ],
                              staticClass: "tbl_col mt10",
                            },
                            [
                              _c("colgroup", [
                                _c("col", { attrs: { width: "30%" } }),
                                _c("col", { attrs: { width: "12%" } }),
                                _c("col", { attrs: { width: "10%" } }),
                                _c("col", { attrs: { width: "12%" } }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v20Yn,
                                      expression: "v20Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v40Yn,
                                      expression: "v40Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v40Yn,
                                      expression: "v40Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                              ]),
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Export Charges")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Currency")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Type")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Cargo")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v20Yn,
                                          expression: "v20Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("20'")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v40Yn,
                                          expression: "v40Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("40'")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v40Yn,
                                          expression: "v40Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("HC")]
                                  ),
                                ]),
                              ]),
                              _vm._l(_vm.surChargeListDry, function (row, idx) {
                                return _c("tr", { key: "a" + idx }, [
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                      staticClass: "text_left",
                                    },
                                    [_vm._v(_vm._s(row.frtCdNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.curCd))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.cntrTypCd === "RF"
                                            ? "Reefer"
                                            : row.cntrTypCd
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.cgoTypNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v20Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v20Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rate20,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rate40,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rateHc,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                            ],
                            2
                          ),
                          _c(
                            "table",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.detailYn === "Y",
                                  expression: "detailYn === 'Y'",
                                },
                              ],
                              staticClass: "tbl_col mt10",
                            },
                            [
                              _c("colgroup", [
                                _c("col", { attrs: { width: "30%" } }),
                                _c("col", { attrs: { width: "12%" } }),
                                _c("col", { attrs: { width: "10%" } }),
                                _c("col", { attrs: { width: "12%" } }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v20Yn,
                                      expression: "v20Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v40Yn,
                                      expression: "v40Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v40Yn,
                                      expression: "v40Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                              ]),
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Import Charges")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Currency")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Type")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Cargo")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v20Yn,
                                          expression: "v20Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("20'")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v40Yn,
                                          expression: "v40Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("40'")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v40Yn,
                                          expression: "v40Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("HC")]
                                  ),
                                ]),
                              ]),
                              _vm._l(_vm.surChargeListDry, function (row, idx) {
                                return _c("tr", { key: "a" + idx }, [
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                      staticClass: "text_left",
                                    },
                                    [_vm._v(_vm._s(row.frtCdNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.curCd))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.cntrTypCd === "RF"
                                            ? "Reefer"
                                            : row.cntrTypCd
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.cgoTypNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v20Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v20Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rate20,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rate40,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rateHc,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.surChargeNoteGPList.length !== 0 &&
                                    _vm.detailYn === "Y",
                                  expression:
                                    "surChargeNoteGPList.length !== 0 && detailYn === 'Y'",
                                },
                              ],
                            },
                            [
                              _vm._m(5),
                              _vm._l(
                                _vm.surChargeNoteGPList,
                                function (row, idx) {
                                  return _c("div", { key: idx }, [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              row.frtCd === "DCF" ||
                                              row.frtCd === "SRD" ||
                                              row.frtCd === "AFS" ||
                                              row.frtCd === "AMS",
                                            expression:
                                              "row.frtCd === 'DCF' || row.frtCd === 'SRD' || row.frtCd === 'AFS' || row.frtCd === 'AMS'",
                                          },
                                        ],
                                      },
                                      [
                                        _c("p", { staticClass: "txt_desc2" }, [
                                          _vm._v(
                                            _vm._s(idx + 1) +
                                              ". Subject to " +
                                              _vm._s(row.frtCdNm) +
                                              " : " +
                                              _vm._s(row.curCd) +
                                              " " +
                                              _vm._s(
                                                _vm.$ekmtcCommon.changeNumberFormat(
                                                  row.blRate,
                                                  { isComma: true }
                                                )
                                              ) +
                                              " per Bill of Lading."
                                          ),
                                          _c("br"),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              idx ===
                                              _vm.surChargeNoteGPList.length -
                                                1,
                                            expression:
                                              "idx === (surChargeNoteGPList.length-1)",
                                          },
                                        ],
                                      },
                                      [
                                        _c("p", { staticClass: "txt_desc2" }, [
                                          _vm._v(
                                            _vm._s(idx + 2) +
                                              ". Subject to SPECIAL DG HANDLING SURCHARGE : USD 600/20', USD 700/40' per container (※For only DG CLASS 2 by BUSAN T/S)."
                                          ),
                                          _c("br"),
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.params.porCtrCd === "JP",
                                                expression:
                                                  "params.porCtrCd === 'JP'",
                                              },
                                            ],
                                            staticClass: "txt_desc2",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(idx + 3) +
                                                ". 3ヶ月更新のLSS(Low Sulphur Surcharge)は、お見積もりのタイミングによって表示されない場合がございます。 料率が決まり次第表示されますが、ご不明な点がございましたら弊社営業部までお問い合わせください。"
                                            ),
                                            _c("br"),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "table",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.detailYn === "Y",
                                  expression: "detailYn === 'Y'",
                                },
                              ],
                              staticClass: "tbl_col mt10",
                            },
                            [
                              _vm._m(6),
                              _vm._m(7),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.rateFreeDdsGPList,
                                  function (row, idx) {
                                    return _c("tr", { key: idx }, [
                                      _c("td", { staticClass: "text_left" }, [
                                        _vm._v(_vm._s(row.demDetCatNm)),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.ldGpFreeDds)),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.ldHcFreeDds)),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.disGpFreeDds)),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.disHcFreeDds)),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tapStatus === 2,
                          expression: "tapStatus === 2",
                        },
                      ],
                      staticClass: "content_box",
                      staticStyle: { "background-color": "#F0F5FF" },
                    },
                    [
                      _c(
                        "div",
                        {
                          attrs: { id: "print_screen_rf" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("table", { staticClass: "tbl_col mt10" }, [
                            _c("colgroup", [
                              _c("col", { attrs: { width: "30%" } }),
                              _c("col", { attrs: { width: "12%" } }),
                              _c("col", { attrs: { width: "10%" } }),
                              _c("col", { attrs: { width: "12%" } }),
                              _c("col", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.v20Yn,
                                    expression: "v20Yn",
                                  },
                                ],
                                attrs: { width: "12%" },
                              }),
                              _c("col", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.v40Yn,
                                    expression: "v40Yn",
                                  },
                                ],
                                attrs: { width: "12%" },
                              }),
                              _c("col", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.v40Yn,
                                    expression: "v40Yn",
                                  },
                                ],
                                attrs: { width: "12%" },
                              }),
                            ]),
                            _c("thead", [
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("Freight Charges")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("Currency")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("Type")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("Cargo")]
                                ),
                                _c(
                                  "th",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.v20Yn,
                                        expression: "v20Yn",
                                      },
                                    ],
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("20'")]
                                ),
                                _c(
                                  "th",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.v40Yn,
                                        expression: "v40Yn",
                                      },
                                    ],
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("40'")]
                                ),
                                _c(
                                  "th",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.v40Yn,
                                        expression: "v40Yn",
                                      },
                                    ],
                                    staticStyle: {
                                      color: "black",
                                      "background-color": "#E5EEFF",
                                    },
                                  },
                                  [_vm._v("HC")]
                                ),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.surChargeListRee, function (row, idx) {
                                return _c("tr", { key: idx }, [
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.cgoTypCd !== "01" &&
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.cgoTypCd !== '01' && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                      staticClass: "text_left",
                                      attrs: {
                                        rowspan: row.frtCd == "O/F" ? 2 : 1,
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: `idxRF${idx}` } },
                                        [
                                          _c("span", [_vm._v(" ")]),
                                          _vm._v(_vm._s(row.frtCdNm)),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.curCd))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.cntrTypCd === "RF"
                                            ? "Reefer"
                                            : row.cntrTypCd
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.cgoTypNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v20Yn &&
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v20Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      row.rate20 !== "" &&
                                      row.rate20 !== "0" &&
                                      _vm.frtAppNo === "" &&
                                      _vm.of20Rate !== "" &&
                                      _vm.of20Rate !== undefined
                                        ? _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$ekmtcCommon.changeNumberFormat(
                                                    parseInt(row.rate20) +
                                                      parseInt(_vm.of20Rate),
                                                    { isComma: true }
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : row.rate20 !== "" &&
                                          row.rate20 !== "0" &&
                                          _vm.of20Rate !== "" &&
                                          _vm.of20Rate !== undefined
                                        ? _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$ekmtcCommon.changeNumberFormat(
                                                    parseInt(row.rate20) +
                                                      parseInt(_vm.of20Rate),
                                                    { isComma: true }
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$ekmtcCommon.changeNumberFormat(
                                                  row.rate20,
                                                  { isComma: true }
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      row.rate40 !== "" &&
                                      row.rate40 !== "0" &&
                                      _vm.frtAppNo === "" &&
                                      _vm.of40Rate !== "" &&
                                      _vm.of40Rate !== undefined
                                        ? _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$ekmtcCommon.changeNumberFormat(
                                                    parseInt(row.rate40) +
                                                      parseInt(_vm.of40Rate),
                                                    { isComma: true }
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : row.rate40 !== "" &&
                                          row.rate40 !== "0" &&
                                          _vm.of40Rate !== "" &&
                                          _vm.of40Rate !== undefined
                                        ? _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$ekmtcCommon.changeNumberFormat(
                                                    parseInt(row.rate40) +
                                                      parseInt(_vm.of40Rate),
                                                    { isComma: true }
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$ekmtcCommon.changeNumberFormat(
                                                  row.rate40,
                                                  { isComma: true }
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd === "O/F" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd === 'O/F' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      row.rateHc !== "" &&
                                      row.rateHc !== "0" &&
                                      _vm.frtAppNo === "" &&
                                      _vm.of40Rate !== "" &&
                                      _vm.of40Rate !== undefined
                                        ? _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$ekmtcCommon.changeNumberFormat(
                                                    parseInt(row.rateHc) +
                                                      parseInt(_vm.of40Rate),
                                                    { isComma: true }
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : row.rateHc !== "" &&
                                          row.rateHc !== "0" &&
                                          _vm.of40Rate !== "" &&
                                          _vm.of40Rate !== undefined
                                        ? _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$ekmtcCommon.changeNumberFormat(
                                                    parseInt(row.rateHc) +
                                                      parseInt(_vm.of40Rate),
                                                    { isComma: true }
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$ekmtcCommon.changeNumberFormat(
                                                  row.rateHc,
                                                  { isComma: true }
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]),
                          _c(
                            "table",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.detailYn === "Y",
                                  expression: "detailYn === 'Y'",
                                },
                              ],
                              staticClass: "tbl_col mt10",
                            },
                            [
                              _c("colgroup", [
                                _c("col", { attrs: { width: "30%" } }),
                                _c("col", { attrs: { width: "12%" } }),
                                _c("col", { attrs: { width: "10%" } }),
                                _c("col", { attrs: { width: "12%" } }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v20Yn,
                                      expression: "v20Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v40Yn,
                                      expression: "v40Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v40Yn,
                                      expression: "v40Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                              ]),
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Export Charges")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Currency")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Type")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Cargo")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v20Yn,
                                          expression: "v20Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("20'")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v40Yn,
                                          expression: "v40Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("40'")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v40Yn,
                                          expression: "v40Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("HC")]
                                  ),
                                ]),
                              ]),
                              _vm._l(_vm.surChargeListRee, function (row, idx) {
                                return _c("tr", { key: "a" + idx }, [
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                      staticClass: "text_left",
                                    },
                                    [_vm._v(_vm._s(row.frtCdNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.curCd))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.cntrTypCd === "RF"
                                            ? "Reefer"
                                            : row.cntrTypCd
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.cgoTypNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v20Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v20Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rate20,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rate40,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtCd !== "SRD" &&
                                            row.frtPncCd === "P" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtCd !== 'SRD' && row.frtPncCd === 'P' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rateHc,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                            ],
                            2
                          ),
                          _c(
                            "table",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.detailYn === "Y",
                                  expression: "detailYn === 'Y'",
                                },
                              ],
                              staticClass: "tbl_col mt10",
                            },
                            [
                              _c("colgroup", [
                                _c("col", { attrs: { width: "30%" } }),
                                _c("col", { attrs: { width: "12%" } }),
                                _c("col", { attrs: { width: "10%" } }),
                                _c("col", { attrs: { width: "12%" } }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v20Yn,
                                      expression: "v20Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v40Yn,
                                      expression: "v40Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                                _c("col", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.v40Yn,
                                      expression: "v40Yn",
                                    },
                                  ],
                                  attrs: { width: "12%" },
                                }),
                              ]),
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Import Charges")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Currency")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Type")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("Cargo")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v20Yn,
                                          expression: "v20Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("20'")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v40Yn,
                                          expression: "v40Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("40'")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.v40Yn,
                                          expression: "v40Yn",
                                        },
                                      ],
                                      staticStyle: {
                                        color: "black",
                                        "background-color": "#E5EEFF",
                                      },
                                    },
                                    [_vm._v("HC")]
                                  ),
                                ]),
                              ]),
                              _vm._l(_vm.surChargeListRee, function (row, idx) {
                                return _c("tr", { key: "a" + idx }, [
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                      staticClass: "text_left",
                                    },
                                    [_vm._v(_vm._s(row.frtCdNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.curCd))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.cntrTypCd === "RF"
                                            ? "Reefer"
                                            : row.cntrTypCd
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [_vm._v(_vm._s(row.cgoTypNm))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v20Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v20Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rate20,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rate40,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.v40Yn &&
                                            row.frtCd !== "O/F" &&
                                            row.frtCd !== "DCF" &&
                                            row.frtPncCd === "C" &&
                                            row.cntrTypCd !== "" &&
                                            row.cntrTypCd !== "RH" &&
                                            row.cntrTypCd !== "HC",
                                          expression:
                                            "v40Yn && row.frtCd !== 'O/F' && row.frtCd !== 'DCF' && row.frtPncCd === 'C' && row.cntrTypCd !== '' && row.cntrTypCd !== 'RH' && row.cntrTypCd !== 'HC'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ekmtcCommon.changeNumberFormat(
                                              row.rateHc,
                                              { isComma: true }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.surChargeNoteRFList.length !== 0 &&
                                    _vm.detailYn === "Y",
                                  expression:
                                    "surChargeNoteRFList.length !== 0 && detailYn === 'Y'",
                                },
                              ],
                            },
                            [
                              _vm._m(8),
                              _vm._l(
                                _vm.surChargeNoteRFList,
                                function (row, idx) {
                                  return _c("div", { key: idx }, [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              row.frtCd === "DCF" ||
                                              row.frtCd === "SRD" ||
                                              row.frtCd === "AFS" ||
                                              row.frtCd === "AMS",
                                            expression:
                                              "row.frtCd === 'DCF' || row.frtCd === 'SRD' || row.frtCd === 'AFS' || row.frtCd === 'AMS'",
                                          },
                                        ],
                                      },
                                      [
                                        _c("p", { staticClass: "txt_desc2" }, [
                                          _vm._v(
                                            _vm._s(idx + 1) +
                                              ". Subject to " +
                                              _vm._s(row.frtCdNm) +
                                              " : " +
                                              _vm._s(row.curCd) +
                                              " " +
                                              _vm._s(
                                                _vm.$ekmtcCommon.changeNumberFormat(
                                                  row.blRate,
                                                  { isComma: true }
                                                )
                                              ) +
                                              " per Bill of Lading."
                                          ),
                                          _c("br"),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              idx ===
                                              _vm.surChargeNoteRFList.length -
                                                1,
                                            expression:
                                              "idx === (surChargeNoteRFList.length-1)",
                                          },
                                        ],
                                      },
                                      [
                                        _c("p", { staticClass: "txt_desc2" }, [
                                          _vm._v(
                                            _vm._s(idx + 2) +
                                              ". Subject to SPECIAL DG HANDLING SURCHARGE : USD 600/20', USD 700/40' per container (※For only DG CLASS 2 by BUSAN T/S)."
                                          ),
                                          _c("br"),
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.params.porCtrCd === "JP",
                                                expression:
                                                  "params.porCtrCd === 'JP'",
                                              },
                                            ],
                                            staticClass: "txt_desc2",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(idx + 3) +
                                                ". 3ヶ月更新のLSS(Low Sulphur Surcharge)は、お見積もりのタイミングによって表示されない場合がございます。 料率が決まり次第表示されますが、ご不明な点がございましたら弊社営業部までお問い合わせください。"
                                            ),
                                            _c("br"),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "table",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.detailYn === "Y",
                                  expression: "detailYn === 'Y'",
                                },
                              ],
                              staticClass: "tbl_col mt10",
                            },
                            [
                              _vm._m(9),
                              _vm._m(10),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.rateFreeDdsRFList,
                                  function (row, idx) {
                                    return _c("tr", { key: idx }, [
                                      _c("td", { staticClass: "text_left" }, [
                                        _vm._v(_vm._s(row.demDetCatNm)),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.ldGpFreeDds)),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.ldHcFreeDds)),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.disGpFreeDds)),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(row.disHcFreeDds)),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.kmtcSpotUserYn === "Y" &&
                            _vm.kmtcOnNowDisabledYn !== "Y" &&
                            _vm.tapStatus === 1,
                          expression:
                            "kmtcSpotUserYn === 'Y' && kmtcOnNowDisabledYn !== 'Y' && tapStatus === 1",
                        },
                      ],
                      staticClass: "ml25 mt20 flex_box",
                    },
                    [
                      _c(
                        "li",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            color: "#075bb9",
                            "font-weight": "500",
                          },
                        },
                        [_vm._v("KMTC ON NOW")]
                      ),
                    ]
                  ),
                  _vm.kmtcSpotUserYn === "Y" && _vm.kmtcOnNowDisabledYn === "Y"
                    ? _c(
                        "div",
                        {
                          staticClass: "content_box mt10",
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "center",
                            "text-align": "center",
                            "background-color": "rgba(246, 249, 255)",
                            height: "245px",
                            width: "100%",
                          },
                        },
                        [
                          _c("div", [
                            _vm.kmtcOnNowNoticeMsg !== ""
                              ? _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "font-size": "18px",
                                      "font-weight": "600",
                                      color: "#000",
                                      "margin-bottom": "8px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.kmtcOnNowNoticeMsg) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.kmtcOnNowNoticeSubMsg !== ""
                              ? _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.kmtcOnNowNoticeSubMsg) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.kmtcSpotUserYn === "Y" &&
                            _vm.tapStatus === 1 &&
                            _vm.kmtcOnNowDisabledYn !== "Y",
                          expression:
                            "kmtcSpotUserYn === 'Y' && tapStatus === 1 && kmtcOnNowDisabledYn !== 'Y'",
                        },
                      ],
                      staticClass: "content_box mt10",
                      staticStyle: { "background-color": "#F0F5FF" },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.dcYn != "Y",
                              expression: "dcYn != 'Y'",
                            },
                          ],
                        },
                        [
                          _c(
                            "a",
                            {
                              staticStyle: {
                                "font-size": "medium",
                                color: "black",
                              },
                            },
                            [
                              _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.031"))),
                              _c("br"),
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticStyle: {
                                "font-size": "small",
                                color: "black",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.032")))]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.dcYn == "Y",
                              expression: "dcYn == 'Y'",
                            },
                          ],
                        },
                        [
                          _c(
                            "a",
                            {
                              staticStyle: {
                                "font-size": "medium",
                                color: "black",
                              },
                            },
                            [
                              _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.059"))),
                              _c("br"),
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticStyle: {
                                "font-size": "small",
                                color: "black",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.060")))]
                          ),
                        ]
                      ),
                      _c(
                        "table",
                        { staticStyle: { width: "100%", "margin-top": "5px" } },
                        [
                          _vm._m(11),
                          _c("tbody", [
                            _c("tr", { staticStyle: { width: "100%" } }, [
                              _c("td", { attrs: { colspan: "2" } }, [
                                _c(
                                  "table",
                                  {
                                    staticStyle: {
                                      border: "solid 1px #C7DAFF",
                                      width: "100%",
                                    },
                                  },
                                  [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                            height: "50px",
                                            "font-weight": "500",
                                            "background-color": "#E5EEFF",
                                            width: "150px",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("msg.FARE010T010_NEW.033")
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            "background-color": "#E5EEFF",
                                            "border-right": "0px",
                                          },
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.dcYn != "Y",
                                                expression: "dcYn != 'Y'",
                                              },
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.params.kmtcOnShprNm,
                                                expression:
                                                  "params.kmtcOnShprNm",
                                              },
                                            ],
                                            staticClass: "txt_jp",
                                            staticStyle: {
                                              width: "98%",
                                              "margin-left": "5px",
                                              height: "33px",
                                            },
                                            attrs: {
                                              id: "kmtcOnShprNm",
                                              type: "text",
                                              maxlength: "50",
                                              placeholder:
                                                "Enter B/L Shipper Name",
                                            },
                                            domProps: {
                                              value: _vm.params.kmtcOnShprNm,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.params,
                                                  "kmtcOnShprNm",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.dcYn == "Y",
                                                  expression: "dcYn == 'Y'",
                                                },
                                              ],
                                              staticStyle: {
                                                "font-size": "large",
                                                color: "#075bb9",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.saveShprNm))]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "border-top": "solid 5px #F0F5FF",
                                  },
                                },
                                [
                                  _c(
                                    "table",
                                    {
                                      staticStyle: {
                                        border: "solid 1px #C7DAFF",
                                        width: "100%",
                                      },
                                    },
                                    [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                              height: "50px",
                                              "font-weight": "500",
                                              "background-color": "#E5EEFF",
                                              color: "black",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "20' " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "msg.FARE010T010_NEW.027"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c(
                                        "tr",
                                        { staticStyle: { height: "100px" } },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "background-color": "white",
                                                "border-right": "0px",
                                                height: "33px",
                                              },
                                            },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                    "margin-top": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._m(12),
                                                  _c("tbody", [
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-bottom":
                                                                  "10px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticStyle: {
                                                                    "font-weight":
                                                                      "400",
                                                                    "font-size":
                                                                      "medium",
                                                                    color:
                                                                      "#075bb9",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "msg.FARE010T010_NEW.034"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "large",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                            },
                                                            [_vm._v("USD ")]
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "large",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                              style: {
                                                                textDecorationLine:
                                                                  _vm.dcYn ==
                                                                  "Y"
                                                                    ? "line-through"
                                                                    : "none",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.calcuAmt
                                                                    .from20
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "medium",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                            },
                                                            [_vm._v(" / TEU")]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            "font-weight":
                                                              "700",
                                                          },
                                                        },
                                                        [_vm._v(" → ")]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-bottom":
                                                                  "10px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        _vm.dcYn !=
                                                                        "Y",
                                                                      expression:
                                                                        "dcYn != 'Y'",
                                                                    },
                                                                  ],
                                                                  staticStyle: {
                                                                    "font-weight":
                                                                      "400",
                                                                    "font-size":
                                                                      "medium",
                                                                    color:
                                                                      "#075bb9",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "msg.FARE010T010_NEW.035"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        _vm.dcYn ==
                                                                        "Y",
                                                                      expression:
                                                                        "dcYn == 'Y'",
                                                                    },
                                                                  ],
                                                                  staticStyle: {
                                                                    "font-weight":
                                                                      "400",
                                                                    "font-size":
                                                                      "medium",
                                                                    color:
                                                                      "#075bb9",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "msg.FARE010T010_NEW.036"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("e-input-number", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm.dcYn !=
                                                                  "Y",
                                                                expression:
                                                                  "dcYn != 'Y'",
                                                              },
                                                            ],
                                                            staticStyle: {
                                                              width: "145px",
                                                              "margin-left":
                                                                "5px",
                                                              height: "33px",
                                                            },
                                                            attrs: {
                                                              id: "kmtcOn20",
                                                              maxlength: "5",
                                                              placeholder:
                                                                "Enter your Target Rate",
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                return _vm.setCalcuData()
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.params
                                                                  .kmtcOn20,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.params,
                                                                    "kmtcOn20",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "params.kmtcOn20",
                                                            },
                                                          }),
                                                          _c(
                                                            "a",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.dcYn ==
                                                                    "Y",
                                                                  expression:
                                                                    "dcYn == 'Y'",
                                                                },
                                                              ],
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "large",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "USD " +
                                                                  _vm._s(
                                                                    _vm.calcuAmt
                                                                      .kmtcFrom20
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "medium",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                            },
                                                            [_vm._v(" / TEU")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "border-left": "solid 5px #F0F5FF",
                                    "border-top": "solid 5px #F0F5FF",
                                  },
                                },
                                [
                                  _c(
                                    "table",
                                    {
                                      staticStyle: {
                                        border: "solid 1px #C7DAFF",
                                        width: "100%",
                                      },
                                    },
                                    [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                              height: "50px",
                                              "font-weight": "500",
                                              "background-color": "#E5EEFF",
                                              color: "black",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "40' " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "msg.FARE010T010_NEW.027"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c(
                                        "tr",
                                        { staticStyle: { height: "100px" } },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "background-color": "white",
                                                "border-right": "0px",
                                                height: "33px",
                                              },
                                            },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                    "margin-top": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._m(13),
                                                  _c("tbody", [
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-bottom":
                                                                  "10px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticStyle: {
                                                                    "font-weight":
                                                                      "400",
                                                                    "font-size":
                                                                      "medium",
                                                                    color:
                                                                      "#075bb9",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "msg.FARE010T010_NEW.034"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "large",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                            },
                                                            [_vm._v("USD ")]
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "large",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                              style: {
                                                                textDecorationLine:
                                                                  _vm.dcYn ==
                                                                  "Y"
                                                                    ? "line-through"
                                                                    : "none",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.calcuAmt
                                                                    .from40
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "medium",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                            },
                                                            [_vm._v(" / FEU")]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            "font-weight":
                                                              "700",
                                                          },
                                                        },
                                                        [_vm._v(" → ")]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-bottom":
                                                                  "10px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        _vm.dcYn !=
                                                                        "Y",
                                                                      expression:
                                                                        "dcYn != 'Y'",
                                                                    },
                                                                  ],
                                                                  staticStyle: {
                                                                    "font-weight":
                                                                      "400",
                                                                    "font-size":
                                                                      "medium",
                                                                    color:
                                                                      "#075bb9",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "msg.FARE010T010_NEW.035"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        _vm.dcYn ==
                                                                        "Y",
                                                                      expression:
                                                                        "dcYn == 'Y'",
                                                                    },
                                                                  ],
                                                                  staticStyle: {
                                                                    "font-weight":
                                                                      "400",
                                                                    "font-size":
                                                                      "medium",
                                                                    color:
                                                                      "#075bb9",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "msg.FARE010T010_NEW.036"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("e-input-number", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm.dcYn !=
                                                                  "Y",
                                                                expression:
                                                                  "dcYn != 'Y'",
                                                              },
                                                            ],
                                                            staticStyle: {
                                                              width: "145px",
                                                              "margin-left":
                                                                "5px",
                                                              height: "33px",
                                                            },
                                                            attrs: {
                                                              id: "kmtcOn40",
                                                              maxlength: "50",
                                                              placeholder:
                                                                "Enter your Target Rate",
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                return _vm.setCalcuData()
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.params
                                                                  .kmtcOn40,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.params,
                                                                    "kmtcOn40",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "params.kmtcOn40",
                                                            },
                                                          }),
                                                          _c(
                                                            "a",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.dcYn ==
                                                                    "Y",
                                                                  expression:
                                                                    "dcYn == 'Y'",
                                                                },
                                                              ],
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "large",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "USD " +
                                                                  _vm._s(
                                                                    _vm.calcuAmt
                                                                      .kmtcFrom40
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                                "font-size":
                                                                  "medium",
                                                                color:
                                                                  "#075bb9",
                                                              },
                                                            },
                                                            [_vm._v(" / FEU")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "tr",
                              { staticStyle: { border: "solid 5px #F0F5FF" } },
                              [
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      border: "solid 5px #F0F5FF",
                                    },
                                    attrs: { colspan: "2" },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "button blue lg",
                                        staticStyle: {
                                          height: "32px",
                                          width: "96.5%",
                                        },
                                        attrs: { id: "kmtcOnApply", href: "#" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.kmtcOnNegoRequest()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("msg.FARE010T010_NEW.038")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  staticClass: "content_box mt10",
                },
                [
                  _c("div", { staticClass: "mt10 ml10 mb10" }, [
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            "font-weight": "400",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.039")))]
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "font-size": "20px",
                            color: "#075bb9",
                            "font-weight": "500",
                          },
                        },
                        [_vm._v(_vm._s(_vm.eyInfo.content1))]
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "font-size": "10px",
                            "font-weight": "300",
                          },
                        },
                        [_vm._v(_vm._s(_vm.eyInfo.content2))]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.tapStatus === 1 &&
                        _vm.searchYn &&
                        _vm.couponGPList.length > 0,
                      expression:
                        "tapStatus === 1 && searchYn && couponGPList.length > 0",
                    },
                  ],
                  staticClass: "content_box mt10",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ml25",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.showCpDetail()
                        },
                      },
                    },
                    [
                      _c(
                        "li",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            color: "#075bb9",
                            "font-weight": "500",
                          },
                        },
                        [_vm._v("추가 할인 혜택")]
                      ),
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "white-space": "pre-line",
                            display: "contents",
                            "font-size": "14px",
                            color: "#075bb9",
                          },
                        },
                        [
                          _vm._v(
                            "선적 완료 후 정산 시, 조건을 충족한 경우 적용"
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "-15px",
                            float: "right",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticStyle: {
                                "font-size": "small",
                                color: "#075bb9",
                              },
                            },
                            [
                              _vm._v(" 자세히 보기 "),
                              _c("a", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.cpDetailYn !== "Y",
                                    expression: "cpDetailYn !== 'Y'",
                                  },
                                ],
                                staticClass: "tbl_icon new_plus",
                              }),
                              _c("a", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.cpDetailYn === "Y",
                                    expression: "cpDetailYn === 'Y'",
                                  },
                                ],
                                staticClass: "tbl_icon new_minus",
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cpDetailYn === "Y",
                          expression: "cpDetailYn === 'Y'",
                        },
                      ],
                    },
                    [
                      _vm._m(14),
                      _vm._l(_vm.couponGPList, function (row, idx) {
                        return _c(
                          "div",
                          { key: idx, staticStyle: { width: "100%" } },
                          [
                            _c("table", { staticStyle: { width: "100%" } }, [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    style: [
                                      _vm.couponGPList[idx] !== undefined
                                        ? { width: "49%" }
                                        : { width: "100%" },
                                    ],
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          cursor: "pointer",
                                        },
                                        attrs: { for: row.couponNo },
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticStyle: {
                                              "margin-top": "10px",
                                              width: "100%",
                                              border: "1px solid #C7DAFF",
                                              "border-radius": "4px",
                                              "border-style": "hidden",
                                              "box-shadow":
                                                "0 0 0 1px rgb(201, 203, 214)",
                                            },
                                          },
                                          [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "15px",
                                                    "border-top-left-radius":
                                                      "4px",
                                                    "border-top-right-radius":
                                                      "4px",
                                                    height: "50px",
                                                    "font-weight": "500",
                                                    "background-color":
                                                      "#F0F5FF",
                                                    color: "black",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex_box" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "70%",
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    row.chk,
                                                                  expression:
                                                                    "row.chk",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                                id: row.couponNo,
                                                                "true-value":
                                                                  "1",
                                                                "false-value":
                                                                  "0",
                                                              },
                                                              domProps: {
                                                                checked:
                                                                  Array.isArray(
                                                                    row.chk
                                                                  )
                                                                    ? _vm._i(
                                                                        row.chk,
                                                                        null
                                                                      ) > -1
                                                                    : _vm._q(
                                                                        row.chk,
                                                                        "1"
                                                                      ),
                                                              },
                                                              on: {
                                                                change: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        row.chk,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? "1"
                                                                          : "0"
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          null,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            row,
                                                                            "chk",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            row,
                                                                            "chk",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        row,
                                                                        "chk",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.setCalcuData(
                                                                      row.couponTyp ===
                                                                        "05"
                                                                        ? ""
                                                                        : row.couponNo
                                                                    )
                                                                  },
                                                                ],
                                                              },
                                                            }),
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for: row.couponNo,
                                                                },
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-weight":
                                                                            "400",
                                                                          "font-size":
                                                                            "12px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row.content1
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-weight":
                                                                            "500",
                                                                          "font-size":
                                                                            "15px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row.couponNm
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex_box",
                                                          staticStyle: {
                                                            "justify-content":
                                                              "end",
                                                            width: "30%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    row.of20Rate >
                                                                    0,
                                                                  expression:
                                                                    "row.of20Rate > 0",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "content_box mr10",
                                                              staticStyle: {
                                                                "padding-top":
                                                                  "3px",
                                                                height: "30px",
                                                                width:
                                                                  "fit-content",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-weight":
                                                                            "500",
                                                                          "font-size":
                                                                            "10px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "20' "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-weight":
                                                                            "600",
                                                                          "font-size":
                                                                            "13px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "-$" +
                                                                          _vm._s(
                                                                            row.of20Rate
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    row.of40Rate >
                                                                    0,
                                                                  expression:
                                                                    "row.of40Rate > 0",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "content_box mr10",
                                                              staticStyle: {
                                                                "padding-top":
                                                                  "3px",
                                                                height: "30px",
                                                                width:
                                                                  "fit-content",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticStyle: {
                                                                    "font-weight":
                                                                      "500",
                                                                    "font-size":
                                                                      "10px",
                                                                  },
                                                                },
                                                                [_vm._v("40' ")]
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticStyle: {
                                                                    "font-weight":
                                                                      "600",
                                                                    "font-size":
                                                                      "13px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "-$" +
                                                                      _vm._s(
                                                                        row.of40Rate
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  height: "100px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticStyle: {
                                                      "border-bottom-left-radius":
                                                        "4px",
                                                      "border-bottom-right-radius":
                                                        "4px",
                                                      "background-color":
                                                        "white",
                                                      "border-right": "0px",
                                                      height: "33px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "table",
                                                      {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                      },
                                                      [
                                                        _c("tbody", [
                                                          _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticStyle: {
                                                                  "padding-right":
                                                                    "15px",
                                                                  "padding-left":
                                                                    "15px",
                                                                },
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-weight":
                                                                            "400",
                                                                          "font-size":
                                                                            "12px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row.content4
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                                _c("div", [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-weight":
                                                                            "400",
                                                                          "font-size":
                                                                            "12px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row.content3
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                                _c("div", [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-weight":
                                                                            "400",
                                                                          "font-size":
                                                                            "12px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row.content2
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                                _c("div", [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-weight":
                                                                            "400",
                                                                          "font-size":
                                                                            "10px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          row.title
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      _vm._m(15),
                    ],
                    2
                  ),
                ]
              ),
            ]),
            _c("td", { staticStyle: { "align-content": "flex-start" } }, [
              _c("div", { attrs: { id: "calcu" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchYn && _vm.kmtcSpotCoupon === "Y",
                        expression: "searchYn && kmtcSpotCoupon === 'Y'",
                      },
                    ],
                    staticClass: "content_box mt10 ml10",
                    staticStyle: { padding: "8px", width: "295px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tapStatus === 1,
                            expression: "tapStatus === 1",
                          },
                        ],
                        staticClass: "flex_box",
                        staticStyle: { float: "right" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              width: "37%",
                              "flex-direction": "row-reverse",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showFree,
                                    expression: "showFree",
                                  },
                                ],
                                staticClass:
                                  "tooltip_wrap short position_absolute",
                                staticStyle: {
                                  "background-color": "#F0F5FF",
                                  width: "685px",
                                  left: "-650px",
                                  top: "31px",
                                  "padding-bottom": "11px",
                                },
                              },
                              [
                                _vm._m(16),
                                _c(
                                  "button",
                                  {
                                    staticClass: "close",
                                    staticStyle: { right: "16px", top: "17px" },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.showFree = false
                                      },
                                    },
                                  },
                                  [_vm._v("close")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "cont",
                                    staticStyle: {
                                      padding: "0px",
                                      "margin-right": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "ul",
                                      { staticClass: "bul_list_sm t2" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "content_box mt10 ml10",
                                            staticStyle: { padding: "10px" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "port",
                                                staticStyle: {
                                                  height: "36px",
                                                  "font-size": "large",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.params.polNm)
                                                  ),
                                                ]),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      background:
                                                        "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlFNkVCMDQ3RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlFNkVCMDQ4RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUU2RUIwNDVGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUU2RUIwNDZGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kdiepAAAACVBMVEWDrdz///8HW7mfiL2lAAAAIElEQVR42mJgYGRkZGBiABFAEkgwMcAIBqgESAlAgAEAAwIAJbZf+5AAAAAASUVORK5CYII=) no-repeat 0 11px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.params.podNm)
                                                    ),
                                                  ]
                                                ),
                                                this.startDtGP !== ""
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticStyle: {
                                                          display: "list-item",
                                                          "margin-left": "25px",
                                                          "margin-top": "6px",
                                                          float: "right",
                                                          "font-size": "small",
                                                          color: "black",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Freight Validity Period : " +
                                                            _vm._s(
                                                              this.startDtGP
                                                            ) +
                                                            " ~ " +
                                                            _vm._s(this.endDtGP)
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "content_box",
                                                staticStyle: {
                                                  padding: "10px",
                                                  "background-color": "#F0F5FF",
                                                },
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  { staticClass: "tbl_col" },
                                                  [
                                                    _vm._m(17),
                                                    _vm._m(18),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.rateFreeDdsGPList,
                                                        function (row, idx) {
                                                          return _c(
                                                            "tr",
                                                            { key: idx },
                                                            [
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text_left",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      row.demDetCatNm
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.ldGpFreeDds
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.ldHcFreeDds
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.disGpFreeDds
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.disHcFreeDds
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "mt10",
                                    staticStyle: { "text-align": "center" },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button",
                                        staticStyle: {
                                          width: "100px",
                                          color: "white",
                                          "background-color": "black",
                                        },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showFree = false
                                          },
                                        },
                                      },
                                      [_vm._v("Close")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tapStatus === 2,
                            expression: "tapStatus === 2",
                          },
                        ],
                        staticClass: "flex_box",
                        staticStyle: { float: "right" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              width: "37%",
                              "flex-direction": "row-reverse",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showFree,
                                    expression: "showFree",
                                  },
                                ],
                                staticClass:
                                  "tooltip_wrap short position_absolute",
                                staticStyle: {
                                  "background-color": "#F0F5FF",
                                  width: "685px",
                                  left: "-650px",
                                  top: "31px",
                                  "padding-bottom": "11px",
                                },
                              },
                              [
                                _vm._m(19),
                                _c(
                                  "button",
                                  {
                                    staticClass: "close",
                                    staticStyle: { right: "16px", top: "17px" },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.showFree = false
                                      },
                                    },
                                  },
                                  [_vm._v("close")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "cont",
                                    staticStyle: {
                                      padding: "0px",
                                      "margin-right": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "ul",
                                      { staticClass: "bul_list_sm t2" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "content_box mt10 ml10",
                                            staticStyle: { padding: "10px" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "port",
                                                staticStyle: {
                                                  height: "36px",
                                                  "font-size": "large",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.params.polNm)
                                                  ),
                                                ]),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      background:
                                                        "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlFNkVCMDQ3RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlFNkVCMDQ4RjBDRDExRUJCNEVFRDE5NkIxRDJGNjJGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUU2RUIwNDVGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUU2RUIwNDZGMENEMTFFQkI0RUVEMTk2QjFEMkY2MkYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7kdiepAAAACVBMVEWDrdz///8HW7mfiL2lAAAAIElEQVR42mJgYGRkZGBiABFAEkgwMcAIBqgESAlAgAEAAwIAJbZf+5AAAAAASUVORK5CYII=) no-repeat 0 11px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.params.podNm)
                                                    ),
                                                  ]
                                                ),
                                                this.startDtRF !== ""
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticStyle: {
                                                          display: "list-item",
                                                          "margin-left": "25px",
                                                          "margin-top": "6px",
                                                          float: "right",
                                                          "font-size": "small",
                                                          color: "black",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Freight Validity Period : " +
                                                            _vm._s(
                                                              this.startDtRF
                                                            ) +
                                                            " ~ " +
                                                            _vm._s(this.endDtRF)
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "content_box",
                                                staticStyle: {
                                                  padding: "10px",
                                                  "background-color": "#F0F5FF",
                                                },
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  { staticClass: "tbl_col" },
                                                  [
                                                    _vm._m(20),
                                                    _vm._m(21),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.rateFreeDdsRFList,
                                                        function (row, idx) {
                                                          return _c(
                                                            "tr",
                                                            { key: idx },
                                                            [
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text_left",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      row.demDetCatNm
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.ldGpFreeDds
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.ldHcFreeDds
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.disGpFreeDds
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.disHcFreeDds
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "mt10",
                                    staticStyle: { "text-align": "center" },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button",
                                        staticStyle: {
                                          width: "100px",
                                          color: "white",
                                          "background-color": "black",
                                        },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showFree = false
                                          },
                                        },
                                      },
                                      [_vm._v("Close")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "flex_box" }, [
                      _c("div", [
                        _c("a", { staticStyle: { "font-weight": "500" } }, [
                          _c("span", { staticClass: "tbl_icon new_note" }),
                          _vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.053"))),
                        ]),
                      ]),
                      _c("div", { staticStyle: { width: "50%" } }, [
                        _vm.calcuAmt.kmtcOn20 + _vm.calcuAmt.kmtcOn40 > 0
                          ? _c(
                              "a",
                              {
                                staticStyle: {
                                  "font-weight": "400",
                                  "font-size": "smaller",
                                  color: "rgb(7, 91, 185)",
                                  display: "flex",
                                  width: "100%",
                                  "flex-direction": "row-reverse",
                                },
                              },
                              [_vm._v("✓ 금액 협상 완료")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "content_box mb10",
                        staticStyle: {
                          padding: "7px",
                          "align-content": "center",
                          "text-align": "center",
                          "background-color": "rgba(246, 249, 255)",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.v20Yn,
                                expression: "v20Yn",
                              },
                            ],
                            staticClass: "content_box",
                            staticStyle: {
                              "border-bottom-left-radius": "0",
                              "border-bottom-right-radius": "0",
                              padding: "7px",
                            },
                          },
                          [
                            _c("div", { staticClass: "flex_box" }, [
                              _c("div", { staticStyle: { width: "60%" } }, [
                                _c(
                                  "th",
                                  { staticStyle: { "font-weight": "400" } },
                                  [
                                    _vm._v(
                                      "20' " +
                                        _vm._s(
                                          _vm.$t("msg.FARE010T010_NEW.027")
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticStyle: { width: "100%" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-right": "4px",
                                      display: "flex",
                                      width: "100%",
                                      "flex-direction": "row-reverse",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      { staticStyle: { "font-weight": "400" } },
                                      [
                                        _vm._v(
                                          " $" +
                                            _vm._s(
                                              _vm.calcuAmt.from20 -
                                                _vm.calcuAmt.kmtcOn20
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.v40Yn,
                                expression: "v40Yn",
                              },
                            ],
                            staticClass: "content_box",
                            staticStyle: {
                              "border-bottom-left-radius": "0",
                              "border-bottom-right-radius": "0",
                              padding: "7px",
                            },
                          },
                          [
                            _c("div", { staticClass: "flex_box" }, [
                              _c("div", { staticStyle: { width: "60%" } }, [
                                _c(
                                  "th",
                                  { staticStyle: { "font-weight": "400" } },
                                  [
                                    _vm._v(
                                      "40' " +
                                        _vm._s(
                                          _vm.$t("msg.FARE010T010_NEW.027")
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticStyle: { width: "100%" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-right": "4px",
                                      display: "flex",
                                      width: "100%",
                                      "flex-direction": "row-reverse",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      { staticStyle: { "font-weight": "400" } },
                                      [
                                        _vm._v(
                                          " $" +
                                            _vm._s(
                                              _vm.calcuAmt.from40 -
                                                _vm.calcuAmt.kmtcOn40
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm.vHZYn
                          ? _c(
                              "div",
                              {
                                staticClass: "content_box",
                                staticStyle: {
                                  "border-bottom-left-radius": "0",
                                  "border-bottom-right-radius": "0",
                                  padding: "7px",
                                },
                              },
                              [
                                _c("div", { staticClass: "flex_box" }, [
                                  _vm._m(22),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        "flex-direction": "row-reverse",
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticStyle: { "font-weight": "400" },
                                        },
                                        [
                                          _vm._v(
                                            " $" + _vm._s(_vm.calcuAmt.hzFrom20)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm.vHZYn
                          ? _c(
                              "div",
                              {
                                staticClass: "content_box",
                                staticStyle: {
                                  "border-bottom-left-radius": "0",
                                  "border-bottom-right-radius": "0",
                                  padding: "7px",
                                },
                              },
                              [
                                _c("div", { staticClass: "flex_box" }, [
                                  _vm._m(23),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        "flex-direction": "row-reverse",
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticStyle: { "font-weight": "400" },
                                        },
                                        [
                                          _vm._v(
                                            " $" + _vm._s(_vm.calcuAmt.hzFrom40)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _c("div", {
                          staticStyle: {
                            "border-bottom": "ridge",
                            padding: "3px",
                          },
                        }),
                        _vm._m(24),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tapStatus === 1 &&
                          _vm.searchYn &&
                          _vm.couponGPList.length > 0 &&
                          _vm.kmtcSpotCoupon === "Y",
                        expression:
                          "tapStatus === 1 && searchYn && couponGPList.length > 0 && kmtcSpotCoupon === 'Y'",
                      },
                    ],
                    staticClass: "content_box mt10 ml10",
                    staticStyle: { padding: "8px", width: "295px" },
                  },
                  [
                    _vm._m(25),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.calcuAmt.coup20 + _vm.calcuAmt.lightC <= 0 &&
                              _vm.calcuAmt.coup40 + _vm.calcuAmt.lightC40 <= 0,
                            expression:
                              "calcuAmt.coup20+calcuAmt.lightC <= 0 && calcuAmt.coup40+calcuAmt.lightC40 <= 0",
                          },
                        ],
                        staticClass: "content_box",
                        staticStyle: {
                          height: "105px",
                          "align-content": "center",
                          "text-align": "center",
                          "font-size": "12px",
                        },
                      },
                      [_vm._m(26)]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.calcuAmt.coup20 + _vm.calcuAmt.lightC > 0 ||
                              _vm.calcuAmt.coup40 + _vm.calcuAmt.lightC40 > 0,
                            expression:
                              "calcuAmt.coup20+calcuAmt.lightC > 0 || calcuAmt.coup40+calcuAmt.lightC40 > 0",
                          },
                        ],
                        staticClass: "content_box",
                        staticStyle: {
                          padding: "7px",
                          "align-content": "center",
                          "text-align": "center",
                          "background-color": "rgba(246, 249, 255)",
                        },
                      },
                      [
                        _vm._m(27),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.v20Yn,
                                expression: "v20Yn",
                              },
                            ],
                            staticClass: "content_box",
                            staticStyle: {
                              "border-bottom-left-radius": "0",
                              "border-bottom-right-radius": "0",
                              padding: "7px",
                            },
                          },
                          [
                            _c("div", { staticClass: "flex_box" }, [
                              _c("div", { staticStyle: { width: "70%" } }, [
                                _c(
                                  "th",
                                  { staticStyle: { "font-weight": "400" } },
                                  [
                                    _vm._v(
                                      "20' " +
                                        _vm._s(
                                          _vm.$t("msg.FARE010T010_NEW.027")
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    width: "30%",
                                    "flex-direction": "row-reverse",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "font-size": "smaller",
                                        "font-weight": "400",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.calcuAmt.coup20 +
                                              _vm.calcuAmt.lightC
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.v40Yn,
                                expression: "v40Yn",
                              },
                            ],
                            staticClass: "content_box",
                            staticStyle: {
                              "border-bottom-left-radius": "0",
                              "border-bottom-right-radius": "0",
                              padding: "7px",
                            },
                          },
                          [
                            _c("div", { staticClass: "flex_box" }, [
                              _c("div", { staticStyle: { width: "70%" } }, [
                                _c(
                                  "th",
                                  { staticStyle: { "font-weight": "400" } },
                                  [
                                    _vm._v(
                                      "40' / HC " +
                                        _vm._s(
                                          _vm.$t("msg.FARE010T010_NEW.027")
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    width: "30%",
                                    "flex-direction": "row-reverse",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "font-size": "smaller",
                                        "font-weight": "400",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.calcuAmt.coup40 +
                                              _vm.calcuAmt.lightC40
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.calcuAmt.coup20 + _vm.calcuAmt.lightC > 0 ||
                              _vm.calcuAmt.coup40 + _vm.calcuAmt.lightC40 > 0,
                            expression:
                              "calcuAmt.coup20+calcuAmt.lightC > 0 || calcuAmt.coup40+calcuAmt.lightC40 > 0",
                          },
                        ],
                        staticClass: "content_box",
                        staticStyle: {
                          "margin-top": "10px",
                          padding: "7px",
                          "align-content": "center",
                          "text-align": "center",
                          "background-color": "rgba(246, 249, 255)",
                        },
                      },
                      [
                        _vm._m(28),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.v20Yn,
                                expression: "v20Yn",
                              },
                            ],
                            staticClass: "content_box",
                            staticStyle: {
                              "border-bottom-left-radius": "0",
                              "border-bottom-right-radius": "0",
                              padding: "7px",
                            },
                          },
                          [
                            _c("div", { staticClass: "flex_box" }, [
                              _c("div", { staticStyle: { width: "70%" } }, [
                                _c(
                                  "th",
                                  { staticStyle: { "font-weight": "400" } },
                                  [
                                    _vm._v(
                                      "20' " +
                                        _vm._s(
                                          _vm.$t("msg.FARE010T010_NEW.027")
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    width: "30%",
                                    "flex-direction": "row-reverse",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "font-size": "smaller",
                                        "font-weight": "400",
                                      },
                                    },
                                    [_vm._v("$ " + _vm._s(_vm.calcuAmt.to20))]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.v40Yn,
                                expression: "v40Yn",
                              },
                            ],
                            staticClass: "content_box",
                            staticStyle: {
                              "border-bottom-left-radius": "0",
                              "border-bottom-right-radius": "0",
                              padding: "7px",
                            },
                          },
                          [
                            _c("div", { staticClass: "flex_box" }, [
                              _c("div", { staticStyle: { width: "70%" } }, [
                                _c(
                                  "th",
                                  { staticStyle: { "font-weight": "400" } },
                                  [
                                    _vm._v(
                                      "40' / HC " +
                                        _vm._s(
                                          _vm.$t("msg.FARE010T010_NEW.027")
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    width: "30%",
                                    "flex-direction": "row-reverse",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "font-size": "smaller",
                                        "font-weight": "400",
                                      },
                                    },
                                    [_vm._v("$ " + _vm._s(_vm.calcuAmt.to40))]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._m(29),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchYn,
                        expression: "searchYn",
                      },
                    ],
                    staticStyle: {
                      "margin-top": "10px",
                      "margin-left": "10px",
                      width: "273px",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "button blue lg",
                        staticStyle: { height: "32px", width: "96.5%" },
                        attrs: { id: "raBtn", href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.saveFreightQuotation.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("msg.FARE010T010_NEW.052")))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchYn,
                        expression: "searchYn",
                      },
                    ],
                    staticStyle: {
                      "margin-top": "5px",
                      "margin-left": "10px",
                      width: "273px",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "button grey lg",
                        staticStyle: { height: "35px", width: "96.5%" },
                        attrs: { id: "bkgBtn", href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.goBooking()
                          },
                        },
                      },
                      [_vm._v("Booking")]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          staticClass: "content_box",
          staticStyle: {
            "background-color": "rgb(246, 249, 255)",
            padding: "5px",
            "border-radius": "0px",
            "border-color": "white",
            position: "fixed",
            "z-index": "101",
            width: "100%",
            bottom: "0px",
            left: "0px",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "flex_box",
              staticStyle: {
                "margin-left": "8%",
                "text-align": "right",
                height: "45px",
                "font-size": "x-large",
              },
            },
            [
              _c(
                "a",
                {
                  staticClass: "button grey lg",
                  staticStyle: {
                    color: "black",
                    "border-color": "black",
                    cursor: "unset",
                    height: "35px",
                    width: "99px",
                    "border-radius": "50px",
                    "align-content": "center",
                    "font-size": "large",
                    "font-weight": "600",
                  },
                },
                [_vm._v("예상 운임")]
              ),
              _c(
                "div",
                { staticStyle: { width: "937px", "text-align": "left" } },
                [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.v20Yn,
                          expression: "v20Yn",
                        },
                      ],
                      staticClass: "button grey lg",
                      staticStyle: {
                        color: "black",
                        "border-color": "black",
                        cursor: "unset",
                        height: "35px",
                        width: "150px",
                        "border-radius": "50px",
                        "align-content": "center",
                        "font-size": "large",
                        "margin-left": "10px",
                        "font-weight": "600",
                      },
                    },
                    [_vm._v("20' $ " + _vm._s(_vm.calcuAmt.to20) + " / TEU")]
                  ),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.v20Yn && _vm.vHZYn,
                          expression: "v20Yn && vHZYn",
                        },
                      ],
                      staticClass: "button grey lg",
                      staticStyle: {
                        color: "black",
                        "border-color": "black",
                        cursor: "unset",
                        height: "35px",
                        width: "200px",
                        "border-radius": "50px",
                        "align-content": "center",
                        "font-size": "large",
                        "margin-left": "10px",
                        "font-weight": "600",
                      },
                    },
                    [
                      _vm._v(
                        "20' HZ $ " + _vm._s(_vm.calcuAmt.hzTo20) + " / TEU"
                      ),
                    ]
                  ),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.v40Yn,
                          expression: "v40Yn",
                        },
                      ],
                      staticClass: "button grey lg",
                      staticStyle: {
                        color: "black",
                        "border-color": "black",
                        cursor: "unset",
                        height: "35px",
                        width: "150px",
                        "border-radius": "50px",
                        "align-content": "center",
                        "font-size": "large",
                        "margin-left": "10px",
                        "font-weight": "600",
                      },
                    },
                    [_vm._v("40' $ " + _vm._s(_vm.calcuAmt.to40) + " / FEU")]
                  ),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.v40Yn && _vm.vHZYn,
                          expression: "v40Yn && vHZYn",
                        },
                      ],
                      staticClass: "button grey lg",
                      staticStyle: {
                        color: "black",
                        "border-color": "black",
                        cursor: "unset",
                        height: "35px",
                        width: "200px",
                        "border-radius": "50px",
                        "align-content": "center",
                        "font-size": "large",
                        "margin-left": "10px",
                        "font-weight": "600",
                      },
                    },
                    [
                      _vm._v(
                        "40' HZ $ " + _vm._s(_vm.calcuAmt.hzTo40) + " / FEU"
                      ),
                    ]
                  ),
                ]
              ),
              _c("a", { staticStyle: { "margin-right": "1%" } }, [_vm._v("|")]),
              _c(
                "a",
                {
                  staticClass: "button blue lg",
                  staticStyle: {
                    height: "35px",
                    width: "100px",
                    "border-radius": "50px",
                    "align-content": "center",
                    "font-size": "large",
                  },
                  attrs: { id: "raBtn", href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.saveFreightQuotation.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("운임확인")]
              ),
              _c(
                "a",
                {
                  staticClass: "button grey lg",
                  staticStyle: {
                    height: "35px",
                    width: "100px",
                    "border-radius": "50px",
                    "align-content": "center",
                    "font-size": "large",
                    "margin-right": "15%",
                    "margin-left": "10px",
                  },
                  attrs: { id: "bkgBtn", href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.goBooking()
                    },
                  },
                },
                [_vm._v("Booking")]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "cntr20Yn" } }, [
      _c("span"),
      _vm._v(" 20'"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "cntr40Yn" } }, [
      _c("span"),
      _vm._v(" 40' / HC"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "cntrHzYn" } }, [
      _c("span"),
      _vm._v(" HZ"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "75%" } }),
      _c("col", { attrs: { width: "25%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ml25 flex_box" }, [
      _c(
        "li",
        {
          staticStyle: {
            "font-size": "16px",
            color: "#075bb9",
            "font-weight": "500",
          },
        },
        [_vm._v("FAK(Freight All Kinds)")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "txt_desc asterisk" }, [
      _vm._v("Notes"),
      _c("br"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("KIND")]
        ),
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { colspan: "2" },
          },
          [_vm._v("Loading")]
        ),
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { colspan: "2" },
          },
          [_vm._v("Discharging")]
        ),
      ]),
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: {
              color: "black",
              "background-color": "#E5EEFF",
              "border-left": "1px solid #e1e3eb",
            },
          },
          [_vm._v("GP")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("HC")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("GP")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("HC")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "txt_desc asterisk" }, [
      _vm._v("Notes"),
      _c("br"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("KIND")]
        ),
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { colspan: "2" },
          },
          [_vm._v("Loading")]
        ),
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { colspan: "2" },
          },
          [_vm._v("Discharging")]
        ),
      ]),
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: {
              color: "black",
              "background-color": "#E5EEFF",
              "border-left": "1px solid #e1e3eb",
            },
          },
          [_vm._v("RF")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("RH")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("RF")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("RH")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "50%" } }),
      _c("col", { staticStyle: { width: "50%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "45%" } }),
      _c("col", { staticStyle: { width: "1%" } }),
      _c("col", { staticStyle: { width: "45%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "45%" } }),
      _c("col", { staticStyle: { width: "1%" } }),
      _c("col", { staticStyle: { width: "45%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content_box mt10" }, [
      _c("div", { staticStyle: { "margin-left": "26px" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "font-size": "16px",
              color: "#075bb9",
              "font-weight": "500",
            },
          },
          [_vm._v("최대 혜택을 확인하세요!")]
        ),
        _c(
          "a",
          {
            staticStyle: {
              "white-space": "pre-line",
              display: "contents",
              "font-size": "14px",
              color: "#075bb9",
            },
          },
          [
            _vm._v(
              "아래 쿠폰을 선택하면 받을 수 있는 최대 할인 금액을 미리 계산해드립니다."
            ),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "margin-top": "10px" } }, [
      _c(
        "a",
        {
          staticStyle: {
            "white-space": "pre-line",
            display: "contents",
            "font-size": "14px",
          },
        },
        [
          _vm._v(
            "ⓘ 쿠폰 할인은 확정 운임이 아닙니다. 선적 완료 후 정산 시, 각 쿠폰의 조건을 충족한 경우에만 적용됩니다."
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "mt15 ml15", staticStyle: { "font-size": "large" } },
      [
        _c("th", { staticStyle: { "text-align": "center" } }, [
          _vm._v("Free Time"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("KIND")]
        ),
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { colspan: "2" },
          },
          [_vm._v("Loading")]
        ),
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { colspan: "2" },
          },
          [_vm._v("Discharging")]
        ),
      ]),
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: {
              color: "black",
              "background-color": "#E5EEFF",
              "border-left": "1px solid #e1e3eb",
            },
          },
          [_vm._v("GP")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("HC")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("GP")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("HC")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "mt15 ml15", staticStyle: { "font-size": "large" } },
      [
        _c("th", { staticStyle: { "text-align": "center" } }, [
          _vm._v("Free Time"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "20%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { rowspan: "2" },
          },
          [_vm._v("KIND")]
        ),
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { colspan: "2" },
          },
          [_vm._v("Loading")]
        ),
        _c(
          "th",
          {
            staticStyle: { color: "black", "background-color": "#E5EEFF" },
            attrs: { colspan: "2" },
          },
          [_vm._v("Discharging")]
        ),
      ]),
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: {
              color: "black",
              "background-color": "#E5EEFF",
              "border-left": "1px solid #e1e3eb",
            },
          },
          [_vm._v("RF")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("RH")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("RF")]
        ),
        _c(
          "th",
          { staticStyle: { color: "black", "background-color": "#E5EEFF" } },
          [_vm._v("RH")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "50%" } }, [
      _c("th", { staticStyle: { color: "crimson", "font-weight": "400" } }, [
        _vm._v("20' HZ"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "50%" } }, [
      _c("th", { staticStyle: { color: "crimson", "font-weight": "400" } }, [
        _vm._v("40' / HC HZ"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "text-align": "left" } }, [
      _c(
        "a",
        {
          staticStyle: {
            "white-space": "pre-line",
            display: "contents",
            "font-size": "12px",
          },
        },
        [_vm._v("✓ 운임 파일 생성 시 적용되는 금액입니다")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticStyle: { "font-weight": "500" } }, [
      _c("span", { staticClass: "tbl_icon new_note" }),
      _vm._v("추가 할인 혜택"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", [
      _vm._v("좌측에서 쿠폰을 선택하여"),
      _c("br"),
      _vm._v("추가 혜택을 확인하세요"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex_box mb10" }, [
      _c("div", [
        _c("th", { staticStyle: { "font-weight": "400" } }, [
          _vm._v("예상 최대 할인 금액"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex_box mb10" }, [
      _c("div", [
        _c("th", { staticStyle: { "font-weight": "400" } }, [
          _vm._v("쿠폰 적용 시 예상 최저가"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "content_box mt10",
        staticStyle: { "border-color": "red", "text-align": "left" },
      },
      [
        _c(
          "a",
          {
            staticStyle: {
              color: "red",
              "white-space": "pre-line",
              display: "contents",
              "font-size": "14px",
            },
          },
          [_vm._v("⚠ ")]
        ),
        _c(
          "a",
          {
            staticStyle: {
              "white-space": "pre-line",
              display: "contents",
              "font-size": "12px",
            },
          },
          [_vm._v("쿠폰 조건 충족 시에만 적용")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }